import axios from 'axios'
import base_url from '../../../../main';
import https from "https";
import {useEffect, useState} from "react";
import axiosRetry from 'axios-retry';

/**
 * If basket state changes, all states that rely on it also get updated.
 *
 * @returns {unknown}
 * @constructor
 */
import {Sons} from '../../../../context/theme';

const SimpleItemProvider = ({children, basket, setLoader, setShowUpsaleTitle}) =>{
    const [data, setData] = useState(null);
    const [initialState, setInitialState] = useState(false);

    useEffect(() => {
        if (initialState === false) {
            const searchCriteriaData = searchCriteria(basket.items);
            setInitialState(true);

            if (searchCriteriaData !== '') {
                fetchData(searchCriteriaData).then((res) => {
                    const basketData = basket;
                    let basketItems = [];
                    let finalItems = [];
                    const allowedRoutes = ['customiser', 'frequency-setup', 'frequency-update', 'shopify'];
                    for (let i in basketData.items) {
                        let item = basketData.items[i];
                        if (allowedRoutes.indexOf(item.route) !== -1) {
                            basketItems.push(item.product_id);
                        }
                    }

                    // Only alter the result based on if we have cart items
                    // (Don't crash if user hits basket page with nothing in cart).
                    if (res.data.length > 0 && basketItems.length > 0) {

                        for (let c in res.data) {
                            if (basketItems.indexOf(res.data[c].id) === -1) {
                                finalItems.push(res.data[c]);
                            }
                        }
                        // We don't want to show items that have been added from the customiser here.
                        setData(finalItems);
                    } else {
                        setData(res.data);
                    }

                    setShowUpsaleTitle(true);
                    setInitialState(false);
                });
            } else {
                setLoader(false);
                setData([]);
                setShowUpsaleTitle(false);
            }
        }
    }, [basket])

    const searchCriteria = (items) => {
        let itemsToLoad = [];
        let skip = false;
        let searchString = '';
        for (const count in items) {
            let item = items[count];
            if (typeof item.cross_sell_items !== 'undefined'
                && item.cross_sell_items !== null
                && item.is_frequency
                && !skip) {
                // We need the parent as well for this, find it an array unique + merge. Skip anything else afterwards.
                let parentProduct = [];
                for (let i = 0; i < items.length; i++) {
                    if (item.parent_id === items[i].shopify_product_id) {
                        parentProduct = items[i];
                        skip = true;
                    }
                }

                if (typeof parentProduct.cross_sell_items !== 'undefined') {
                    itemsToLoad = itemsToLoad.concat(item.cross_sell_items).concat(parentProduct.cross_sell_items);
                }
            }
        }

        for (const itemLoadCount in itemsToLoad) {
            searchString += 'id%5B%5D=' + itemsToLoad[itemLoadCount] + '&';
        }

        return searchString;
    }

    axiosRetry(axios, {
        retries: 6,
        shouldResetTimeout: true,
        retryDelay: axiosRetry.exponentialDelay,
    });

    const fetchData = async (searchCriteria) => {
        const instance = axios.create({
            httpsAgent: new https.Agent({
                rejectUnauthorized: false
            }),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'SonsBasket': 'basket'
            },
            timeout: 30000
        });
        const url = base_url['base_url'] + 'api/catalog_product_entities?' + searchCriteria;
        return await instance.get(url);
    }

    const { Provider } = Sons;
    return(
        <Provider value={data}>
            {children}
        </Provider>
    )
}

export default SimpleItemProvider;
